import type { UploadWidgetConfig } from '@bytescale/upload-widget';

import { apiKey, sharedLocale, sharedStyles, uploadBucket } from '../../../../utils';

const sharedPathAd = {
  folderPath: `${uploadBucket}/ads`,
};

/**
 * Kreacja idzie do wielu hoteli naraz, więc kadrowanie zostawiamy adminowi
 * (różne sloty mają różne proporcje) — wymuszamy tylko rozsądny limit wagi,
 * bo obrazek pobiera każde urządzenie gościa przy wejściu na home.
 */
export const optionAdImageUpload: UploadWidgetConfig = {
  apiKey,
  path: sharedPathAd,
  editor: {
    images: {
      preview: true,
      crop: true,
      cropShape: 'rect',
      allowResizeOnMove: true,
    },
  },
  styles: sharedStyles,
  locale: {
    ...sharedLocale,
    cropBtn: 'Kadruj',
    finishBtnIcon: false,
  },
  maxFileCount: 1,
  maxFileSizeBytes: 4 * 1024 * 1024,
  multi: false,
  showRemoveButton: true,
  showFinishButton: true,
};
